import type { FreightType } from "../api/types.ts"

/**
 * 착/선불 — 상자 운임을 받는 쪽이 내는가(collect), 보낸 쪽이 이미 냈는가(prepaid).
 * 서버 `server/src/routes/cases.ts` 의 freightSchema 와 같아야 한다.
 *
 * 표기는 언어 사전(`freight.*`)이 정한다.
 */
export const FREIGHT_TYPES = ["collect", "prepaid"] as const satisfies readonly FreightType[]

/**
 * 착/선불 칸이 미리 골라 두는 값. 고객이 부치는 반품 상자는 거의 다 착불로 들어온다
 * — 선불일 때만 바꿔 고른다.
 */
export const DEFAULT_FREIGHT: FreightType = "collect"
